import { faChevronsRight } from '@fortawesome/pro-solid-svg-icons/faChevronsRight';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ErrorMessage } from '@hookform/error-message';
import {
	Button,
	ColourStateSolid,
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	ValidationError,
} from '@ukpostbox/frontend-framework';
import { useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useState } from 'react';
import { HasTagCondition } from '../Criteria/HasTagCondition';
import { InFolderCondition } from '../Criteria/InFolderCondition';
import { MailTypeCondition } from '../Criteria/MailTypeCondition';
import { ReceivedCondition } from '../Criteria/ReceivedCondition';
import { RecipientCondition } from '../Criteria/RecipientCondition';
import { SenderCondition } from '../Criteria/SenderCondition';
import { RulesetFilterEntryType } from '../../../Types/RulesetTypes';
import { RulesetFilterListData } from '../RulesetData';

function GetFilterType(props: any) {
	const { setValue } = useFormContext();

	switch (props.filterValue) {
		case 0:
			return (
				<SenderCondition
					name={`${props.name}`}
					defaultIncludesValue={props.field.includes || true}
					defaultValue={props.field.values}
					changeCallback={(e: any) => setValue(`${props.name}.includes`, e)}
				/>
			);
		case 1:
			return (
				<ReceivedCondition
					name={`${props.name}.values`}
					defaultValue={props.field.values}
					changeCallback={(e: any) => null}
				/>
			);
		case 2:
			return (
				<RecipientCondition
					name={`${props.name}`}
					defaultIncludesValue={props.field.includes || true}
					defaultValue={props.field.values}
					changeCallback={(e: any) => setValue(`${props.name}.includes`, e)}
				/>
			);
		case 3:
			return (
				<MailTypeCondition
					name={`${props.name}.values`}
					defaultValue={props.field.values}
					changeCallback={(e: any) => setValue(`${props.name}.values`, e)}
				/>
			);
		case 4:
			return (
				<InFolderCondition
					name={`${props.name}.values`}
					defaultValue={props.field.values}
					changeCallback={(e: any) => null}
				/>
			);
		case 5:
			return (
				<HasTagCondition
					name={`${props.name}.values`}
					defaultValue={props.field.values}
					changeCallback={(e: any) => null}
				/>
			);
		default:
			return <div />;
	}
}

function RulesetFilterEntry(props: RulesetFilterEntryType) {
	const { setValue, getFieldState, formState } = useFormContext();
	const [currentFilter, setCurrentFilter] = useState<any>(props.field.value);

	const filterNameSlug = `${props.nameSlug}.${props.fieldIndex}`;

	const AddFilter = (val: any) => {
		setCurrentFilter(val);
		props.addCallback();
	};

	const RemoveFilter = () => {
		props.removeCallback();
	};

	return (
		<div>
			<h6 className='sub-heading mb-xs'>and</h6>

			<div className={`thing-filter ${getFieldState(filterNameSlug).invalid ? 'invalid' : ''}`}>
				<ComboBoxControl
					name={`${filterNameSlug}.id`}
					placeholder='Select Criteria...'
					data={RulesetFilterListData.filter(
						(item) =>
							!Object.values(props.activeFilters)
								.filter((filter) => filter !== currentFilter)
								.includes(item.value),
					)}
					defaultValue={props.field.id ? [props.field.id] : undefined}
					displayType={ComboBoxTypeEnum.Single}
					displayItemLabelType={ComboBoxItemDisplayEnum.Label}
					valueType='number'
					forwardValueCallback={(val) => {
						setValue(`${filterNameSlug}.id`, val);
						AddFilter(val);
					}}
				/>

				<div className='thing-icon'>
					{currentFilter > -1 && <FontAwesomeIcon icon={faChevronsRight} className='hidden' />}
				</div>

				<GetFilterType
					name={filterNameSlug}
					field={props.field}
					filterValue={currentFilter}
					value={props.field.value}
				/>
				<Button
					title='Delete'
					disabled={props.fieldLength <= 1}
					squared
					iconOnly
					colour={ColourStateSolid.Alert}
					extraClass='m-0'
					icon={faTrash}
					onClick={() => RemoveFilter()}
				/>

				<ErrorMessage
					errors={formState.errors}
					name={`${filterNameSlug}.id`}
					render={({ message }) => <ValidationError value={message} />}
				/>
			</div>
		</div>
	);
}

export { RulesetFilterEntry };
